import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Loader, Dimmer } from "semantic-ui-react";
import moment from "moment";
import axios from "axios";
import {
  formatMoneda,
  formatoMonto,
  seleccionarCampo,
  validaMonto,
  validarCantidaddos,
  validaSoloNumero,
} from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import useTableScroll from "../useTableScroll";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import CatalogoNotaEntregaVacios from "../../catalogos/catalogoNotaEntregaVacios";
import CatalogoCliente from "../../catalogos/catalogoCliente";
import CatalogoClassVacios from "../../catalogos/catalogoClassVacios";
import CatalogoAlmacen from "../../catalogos/catalogoAlmacen";

const GestionarVacios = (props) => {
  const op = require("../../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");
  const idVendedor = JSON.parse(sessionStorage.getItem("idagente"));
  const afiliado = JSON.parse(sessionStorage.getItem("riforganizacion"));
  const fechasistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  const cmbCedula = ["J", "V", "G", "P"];

  const txtCliente = useRef();
  const txtDespachado = useRef();
  const txtDevuelto = useRef([]);
  const txtCantidad = useRef([]);
  const txtPendientes = useRef();
  const btnAcepta = useRef();
  const btnCancela = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtFecha = useRef();
  const txtTipogestion = useRef();
  const txtNotaEntrega = useRef();
  const txtAlmacen = useRef();
  const txtIdalmacen = useRef();
  const txtIdcliente = useRef();
  const txtDespachadod = useRef([]);

  const [mostrar, setMostrar] = useState(false);
  const [mostra2, setMostra2] = useState(false);
  const [mostrar3, setMostrar3] = useState(false);
  const [mostrar4, setMostrar4] = useState(false);
  const [records, setRecords] = useState([]);
  const [activate, setActivate] = useState(false);
  const [body, setBody] = useState(null);
  const [detavacios, setDetavacios] = useState(true);
  const [activ, setActiv] = useState(true);
  const [activcliente, setActivcliente] = useState(true);
  const [activnota, setActivnota] = useState(0);
  const [esCredit, setEsCredit] = useState(0);
  const [idAlmacen, setIdAlmacen] = useState(null);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [notavacio, setNotaVacio] = useState({
    idnotavacio: null,
    numnotavacio: null,
    totaldespachado: 0.0,
    totaldevuelto: 0.0,
    totalpendiente: 0.0,
    idcliente: null,
    idvendedor: null,
    idoperacioninventariovacio: null,
    idalmacen: null,
    fecha: "",
    hora: "",
    status: 0,
    tipo: "",
    descripcion: "",
    numnotaentrega: "",
  });
  let nomtabla;
  if (esCredit !== 1) {
    nomtabla = [{ label: "TIPO DE VACIO", textAlign: "center", width: "200px" },
    { label: "DESPACHADO", textAlign: "center", width: "80px" },
    { label: "RETORNADO", textAlign: "center", width: "80px" },
    { label: "PENDIENTES", textAlign: "center", width: "80px" },
    { label: "RETORNAR", textAlign: "center", width: "80px" },
    { label: "--", textAlign: "center", width: "60px" },]
  } else {
    nomtabla = [{ label: "TIPO DE VACIO", textAlign: "center", width: "200px" },
    { label: "PRESTADOS", textAlign: "center", width: "80px" },
    { label: "RETORNADO", textAlign: "center", width: "80px" },
    { label: "PENDIENTES", textAlign: "center", width: "80px" },
    { label: "RETORNAR", textAlign: "center", width: "80px" },
    { label: "--", textAlign: "center", width: "60px" },]
  }
  const headCells = nomtabla;
  const { TblContainer, TblHead } = useTableScroll(headCells);

  const blanquear = () => {
    setMostrar(false);
    setRecords([]);
    setActivnota(0);
    setEsCredit(0);
    setActivcliente(true);
    setActiv(true);
    setIdAlmacen(null);
    setNotaVacio({
      idnotavacio: null,
      numnotavacio: null,
      totaldespachado: 0.0,
      totaldevuelto: 0.0,
      totalpendiente: 0.0,
      idcliente: null,
      idvendedor: null,
      idoperacioninventariovacio: null,
      idalmacen: null,
      fecha: "",
      hora: "",
      status: 0,
      tipo: "",
      descripcion: "",
      numnotaentrega: "",
    });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };

  const onCatalogoCliente = (values) => {
    setMostra2(false);
    txtCliente.current.value = values.nombre;
    cmbRif.current.value = values.rif.substring(0, 1);
    txtRif.current.value = values.rif.substring(1);
    txtIdcliente.current.value = values.idagente;
    setActiv(false);
  };

  const onCatalogoAlmacen = (values) => {
    setMostrar4(false);
    setIdAlmacen(values.idalmacen);
    txtAlmacen.current.value = values.descripcion;
    txtIdalmacen.current.value = values.idalmacen;
  };

  const onCatalogoClassVacios = (values) => {
    setMostrar3(false);

    let data = [...records];
    let datos = [];
    let pas = 0;

    for (let i = 0; i < data.length; i++) {
      if (records[i].idclasevacio === values.idclasevacio) {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "¡ Esta Clase de Vacio ya fue Seleccionada !",
          icono: "informacion",
        });
        return;
      }

      datos.push({
        clasevacio: data[i].clasevacio,
        idproducto: data[i].idproducto,
        despachado: data[i].despachado,
        devuelto: data[i].devuelto,
        pendiente: data[i].pendiente,
        idclasevacio: data[i].idclasevacio,
        cantidad: data[i].cantidad,
        despachadoreal: data[i].despachadoreal,
        devueltoreal: data[i].devueltoreal,
        pendientereal: data[i].pendientereal,
        numfactura: "",
      });

      pas = 1;
    }
    datos.push({
      clasevacio: values.descripcion,
      idproducto: values.idproducto,
      despachado: 0.0,
      devuelto: 0.0,
      pendiente: 0.0,
      idclasevacio: values.idclasevacio,
      cantidad: 0,
      despachadoreal: 0.0,
      devueltoreal: 0.0,
      pendientereal: 0.0,
      numfactura: "",
    });

    setRecords(datos);
    setDetavacios(false);

    if (datos.length > 0) {
      setTimeout(() => txtDespachadod.current[datos.length - 1].focus(), 300);
    }
  };

  const seleccionarNotaEntregaVacios = (numnota) => {
    let endpoint = `${op.conexion}/api/inventariovacio/selecnotaentregavacio?&numnota=${numnota}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            txtNotaEntrega.current.value = response.data[0].numnotaentrega;
            cmbRif.current.value = response.data[0].rifcliente.substring(0, 1);
            txtRif.current.value = response.data[0].rifcliente.substring(1, 11);
            txtCliente.current.value = response.data[0].cliente;
            txtIdalmacen.current.value = response.data[0].idalmacen;
            txtIdcliente.current.value = response.data[0].idcliente;

            let datos = [];
            for (let i = 0; i < response.data.length; i++) {
              datos.push({
                clasevacio: response.data[i].tipovacio,
                idproducto: response.data[i].idproducto,
                despachado: response.data[i].cantidad,
                devuelto: response.data[i].devuelto,
                pendiente:
                  response.data[i].pendiente > 0
                    ? response.data[i].pendiente
                    : response.data[i].cantidad,
                idalmacen: response.data[i].idalmacen,
                idcliente: response.data[i].idcliente,
                idclasevacio: response.data[i].idclasevacio,
                cantidad: 0,
                despachadoreal: response.data[i].cantidad,
                devueltoreal: response.data[i].devuelto,
                pendientereal:
                  response.data[i].pendiente > 0
                    ? response.data[i].pendiente
                    : response.data[i].cantidad,
                numfactura: response.data[i].numnotaentrega,
              });
            }
            setRecords(datos);
            setDetavacios(false);
            setActiv(true);
            if (datos.length > 0) {
              setTimeout(() => txtCantidad.current[0].focus(), 300);
            }
          } else {
            setActiv(true);
            setRecords([]);
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡ N° Nota de Entrega no Existe !",
              icono: "informacion",
            });
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const onChangeValidar = (e) => {
    e.preventDefault();

    let sigue = true;
    if (props.ope === 1) {
      if (activnota === 2) {
        if (txtAlmacen.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Seleccione el Almacen !",
            icono: "informacion",
          });
          sigue = false;
        } else if (txtCliente.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Seleccione el Cliente !",
            icono: "informacion",
          });
          sigue = false;
        } else if (records.length > 0) {
          if (records[0].despachado > 0) {
            sigue = true;
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "¡ Los Campos de la Tabla no deben ir Vacios !",
              icono: "informacion",
            });
            sigue = false;
          }
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Error de Transacción !",
            icono: "informacion",
          });
          sigue = false;
        }
      } else if (activnota === 1) {
        if (txtNotaEntrega.current.value === "") {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Introduzca la Nota de Entrega !",
            icono: "informacion",
          });
          sigue = false;
          txtNotaEntrega.current.focus();
        } else if (records.length > 0) {
          sigue = true;
        } else {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto: "¡ Error de Transacción !",
            icono: "informacion",
          });
          sigue = false;
        }
      } else {
        sigue = true;
      }

      if (sigue === true) {
        let notaentre = [];
        let opeinv = [];
        let notaentredet = [];
        let opeinvdet = [];
        let opeinvdetd = [];

        for (let i = 0; i < records.length; i++) {
          notaentredet.push({
            idclasevacio: records[i].idclasevacio,
            idproducto: records[i].idproducto,
            despachado: records[i].despachado,
            devuelto: records[i].devuelto,
            pendiente: records[i].pendiente,
          });

          if (esCredit !== 0) {
            opeinvdet.push({
              idclasevacio: records[i].idclasevacio,
              cantidad: records[i].despachado,
              tipomovimiento: "RECEPCION",
              fechatipomovimiento: moment(txtFecha.current.value).format(
                "DD-MM-YYYY"
              ),
              numfactura: "",
              idalmacen: txtIdalmacen.current.value,
            });
          } else {
            opeinvdet.push({
              idclasevacio: records[i].idclasevacio,
              cantidad: records[i].despachado,
              tipomovimiento: "DESPACHO",
              fechatipomovimiento: moment(txtFecha.current.value).format(
                "DD-MM-YYYY"
              ),
              numfactura: "",
              idalmacen: txtIdalmacen.current.value,
            });
          }

          if (records[i].cantidad > 0.0) {
            if (esCredit !== 0) {
              opeinvdetd.push({
                idclasevacio: records[i].idclasevacio,
                cantidad: records[i].cantidad,
                tipomovimiento: "DESPACHO",
                fechatipomovimiento: moment(txtFecha.current.value).format(
                  "DD-MM-YYYY"
                ),
                numfactura: "",
                idalmacen: txtIdalmacen.current.value,
              });
            } else {
              opeinvdetd.push({
                idclasevacio: records[i].idclasevacio,
                cantidad: records[i].cantidad,
                tipomovimiento: "RECEPCION",
                fechatipomovimiento: moment(txtFecha.current.value).format(
                  "DD-MM-YYYY"
                ),
                numfactura: "",
                idalmacen: txtIdalmacen.current.value,
              });
            }
          }
        }

        notaentre.push({
          app: false,
          idnotavacio: 0,
          numnotavacio: 0,
          descripcion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
          tipo: activnota === 1 && esCredit !== 1 ? "NE" : esCredit !== 1 ? "NV" : "NC",
          totaldespachado: notavacio.totaldespachado,
          totaldevuelto: notavacio.totaldevuelto,
          totalpendiente: notavacio.totalpendiente,
          idcliente: txtIdcliente.current.value,
          idvendedor: idVendedor,
          fecha: moment(txtFecha.current.value).format("DD-MM-YYYY"),
          status: notavacio.totaldevuelto === notavacio.totaldespachado ? 1 : 0,
          idalmacen: txtIdalmacen.current.value,
          numnotaentrega: activnota === 1 ? txtNotaEntrega.current.value : "N/S",
          notaentredet: notaentredet,
        });

        if (esCredit !== 0) {
          if (opeinvdetd.length > 0) {
            opeinv.push({
              idtipopeinv: 2,
              idoperacioninventario: 0,
              tipooperacion: "SALIDA",
              idalmacenorigen: txtIdalmacen.current.value,
              idalmacendestino: "",
              fecha: moment(txtFecha.current.value).format("DD-MM-YYYY"),
              observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
              numnotavacio: '',
              opeinvdet: opeinvdetd,
            });
          } else {
            opeinv.push({
              idtipopeinv: 1,
              idoperacioninventario: 0,
              tipooperacion: "INGRESO",
              idalmacenorigen: txtIdalmacen.current.value,
              idalmacendestino: "",
              fecha: moment(txtFecha.current.value).format("DD-MM-YYYY"),
              observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
              numnotavacio: '',
              opeinvdet: opeinvdet,
            });
          }
        } else {
          opeinv.push({
            idtipopeinv: 2,
            idoperacioninventario: 0,
            tipooperacion: "SALIDA",
            idalmacenorigen: txtIdalmacen.current.value,
            idalmacendestino: "",
            fecha: moment(txtFecha.current.value).format("DD-MM-YYYY"),
            observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
            numnotavacio: '',
            opeinvdet: opeinvdet,
          });

          if (opeinvdetd.length > 0) {
            opeinv.push({
              idtipopeinv: 1,
              idoperacioninventario: 0,
              tipooperacion: "INGRESO",
              idalmacenorigen: txtIdalmacen.current.value,
              idalmacendestino: "",
              fecha: moment(txtFecha.current.value).format("DD-MM-YYYY"),
              observacion: esCredit !== 1 ? "NOTA DE VACIO" : "CREDITO DE VACIO POR PARTE DEL CLIENTE/PROVEEDOR: " + txtCliente.current.value.toUpperCase().trim(),
              numnotavacio: '',
              opeinvdet: opeinvdetd,
            });
          }
        }
        setBody({
          notaentre: notaentre,
          opeinv: opeinv,
        });

        let msg = "";
        if (props.ope === 1) {
          msg = "Esta Seguro de Procesar este Registro.";
        }

        setMensajesino({
          mostrar: true,
          titulo: "Confirmación.",
          texto: msg,
          icono: "confirmacion",
        });
      }
    }
  };

  const procesarRegistro = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/inventariovacio/actualizarnotavacio/1`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (props.ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Control de Vacio Registrado Correctamente",
              icono: "exito",
            });

            /* var reporte = "ReporteRecibodePago";
            let opera = 2;
            let condi = "'" + response.data.numeropago + "'";
            let tipo = tiponot; */

            /* window.open(
              op.reportes +
              "/finanzas?afiliado=" +
              afiliado +
              "&reporte=" +
              reporte +
              "&NUMPAGO=" +
              condi +
              "&OP=" +
              opera +
              "&TIPOPAGO=" +
              tipo,
              "Planilla",
              "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700"
            ); */
          } else if (props.ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Pago Registrado Correctamente",
              icono: "exito",
            });
          }
          blanquear();
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = error.response.data.message;
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cancelar = () => {
    blanquear();
    setActiv(true);
    setActivcliente(true);
    setActivnota(0);
    props.onHideCancelar();
    setDetavacios(true);
  };

  const cerrarModal = () => {
    blanquear();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideCancelar();
    props.onRenderizar();
  };

  const actualizarVacio = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "cantidad") {
        let cantidades = validarCantidaddos({
          index: index,
          event: event,
          vacios: records,
        });
        if (event.which === 13) {
          if (index < cantidades.data.length) {
            setTimeout(() => txtCantidad.current[index + 1].focus(), 300);
          }
        }

        let data = [...records];

        let cantvacios = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let desp = parseFloat(data[index].despachado);
        let devu = parseFloat(data[index].devueltoreal);
        let valto = devu + cantvacios;
        let pendi = desp - valto;

        if (parseFloat(valto) > parseFloat(data[index].despachado)) {
          setMensaje({
            mostrar: true,
            titulo: "Notificación",
            texto:
              "¡ La Cantidad de Vacios no Debe ser Mayor a la Cantidad Despachado !",
            icono: "informacion",
          });

          data[index].devuelto = data[index].devueltoreal;
          data[index].pendiente = data[index].pendientereal;
          data[index].cantidad = 0.0;
        } else {
          data[index].devuelto =
            cantvacios === 0 ? data[index].devueltoreal : devu + cantvacios;
          data[index].pendiente =
            cantvacios === 0 ? data[index].pendientereal : pendi;
          data[index].cantidad = cantvacios;
        }

        let totalv = 0.0;
        let todevu = 0.0;
        let todespa = 0.0;
        let topendi = 0.0;

        for (let c = 0; c < data.length; c++) {
          totalv = parseFloat(totalv) + parseFloat(data[c].devuelto);
          todevu = parseFloat(todevu) + parseFloat(data[c].devuelto);
          todespa = parseFloat(todespa) + parseFloat(data[c].despachado);
          topendi = parseFloat(topendi) + parseFloat(data[c].pendiente);
        }

        setNotaVacio({
          ...notavacio,
          totaldespachado: todespa,
          totaldevuelto: todevu,
          totalpendiente: topendi,
        });

        setRecords(data);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const actualizarVacioDespachado = (index) => (event) => {
    validaMonto(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (
        event.target.value === "" ||
        parseFloat(
          event.target.value.trim().replace(".", "").replace(",", ".")
        ) === 0.0
      ) {
        event.target.value = "0,00";
      }
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.length
        );
      }
      if (event.target.id === "despachado") {
        let data = [...records];
        let cantvacios = parseFloat(
          event.target.value.replace(/\./g, "").replace(",", ".")
        );

        let devu = parseFloat(data[index].devuelto);

        data[index].despachado = cantvacios;
        data[index].despachadoreal = cantvacios;
        data[index].pendiente = cantvacios - devu;

        let totalv = 0.0;
        let todevu = 0.0;
        let topendi = 0.0;
        let todespa = 0.0;

        for (let i = 0; i < data.length; i++) {
          todespa = todespa + data[i].despachado;
          todevu = todevu + data[i].devuelto;
        }

        topendi = todespa - todevu;

        setNotaVacio({
          ...notavacio,
          totaldespachado: todespa,
          totaldevuelto: todevu,
          totalpendiente: topendi,
        });

        setRecords(data);
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const eliminarVacio = (n) => (e) => {
    e.preventDefault();
    let data = [...records];
    let elementos = [];
    let todevu = 0.0;
    let todespa = 0.0;
    let topendi = 0.0;

    for (let i = 0; i < data.length; i++) {
      if (n.idclasevacio !== data[i].idclasevacio) {
        elementos.push(data[i]);
        todevu = parseFloat(todevu) + parseFloat(data[i].devuelto);
        todespa = parseFloat(todespa) + parseFloat(data[i].despachado);
        topendi = parseFloat(topendi) + parseFloat(data[i].pendiente);
      }
    }

    setNotaVacio({
      ...notavacio,
      totaldespachado: todespa,
      totaldevuelto: todevu,
      totalpendiente: topendi,
    });

    setRecords(elementos);
  };

  const seleccionarCliente = (rif) => {
    let campos =
      "c.idagente, c.nombre as nombrec, substring(trim(c.rif), 1, 1) as tiporifc, substring(trim(c.rif), 2, 10) as rifc";
    let nomtab = "agente as c";
    let nomid = "c.rif";
    let nomid2 = "c.cliente";
    let id = rif;
    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=true`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtCliente.current.value = response.data.nombrec;
            txtRif.current.value = response.data.rifc;
            cmbRif.current.value = response.data.tiporifc;
            setActiv(false);
            //setDetavacios(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No Existe un Cliente con este Número de Documento",
              icono: "informacion",
            });
            setActiv(true);
            txtCliente.current.value = "";
            txtRif.current.value = "";
            cmbRif.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarCliente = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (cmbRif.current.value !== "" && event.target.value !== "") {
        let rif = cmbRif.current.value + event.target.value;
        seleccionarCliente(rif, event.which);
      }
    }
  };

  const onChange = (e) => {
    if (e.target.name === "tipo") {
      setRecords([]);
      setNotaVacio({
        idnotavacio: null,
        numnotavacio: null,
        totaldespachado: 0.0,
        totaldevuelto: 0.0,
        totalpendiente: 0.0,
        idcliente: null,
        idvendedor: null,
        idoperacioninventariovacio: null,
        idalmacen: null,
        fecha: "",
        hora: "",
        status: 0,
        tipo: "",
        descripcion: "",
        numnotaentrega: "",
      });

      cmbRif.current.value = "";
      txtRif.current.value = "";
      txtCliente.current.value = "";

      if (e.target.value === "1") {
        setActivcliente(false);
        setActivnota(2);
        setEsCredit(0);
        txtNotaEntrega.current ? txtNotaEntrega.current.value = "" : "";
      } else if (e.target.value === "2") {
        setActivcliente(true);
        setActivnota(1);
        setEsCredit(0);
      } else {
        setEsCredit(1);
        setActivnota(2);
        setActivcliente(false);
      }
    }
  };

  const handleNotaEntregaVacio = (e) => {
    e.preventDefault();
    if (e.which === 13 || typeof e.which === "undefined") {
      if (e.target.value !== "") {
        seleccionarNotaEntregaVacios(e.target.value);
      }
    }
  };

  const onCatalogoNotaEntrega = (values) => {
    setMostrar(false);
    seleccionarNotaEntregaVacios(values.numnotaentrega);
  };

  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      size="xl"
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props.ope === 1) {
          txtFecha.current.value = moment(fechasistema).format("YYYY-MM-DD");
        }
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Gestionar Entrega de Vacios</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div style={{ height: "100%", width: "100%" }}>
          <div className="row col-md-12" style={{ margin: 0 }}>
            <div className="col-md-12 row border-azul mx-auto rounded py-1">
              <div
                className="col-12 mx-auto mb-1 px-0"
                style={{ fontSizeAdjust: "0.6" }}
              >
                <fieldset className="col-md-12 mx-auto row border-azul rounded py-2">
                  <legend
                    className="float-none m-0 w-auto fw-bold text-black"
                    style={{ fontSize: "1rem" }}
                  >
                    Datos
                  </legend>
                  <div className="input-group input-group-sm mb-2 col-pd-330 px-1">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      TIPO DE GESTION:{" "}
                    </label>
                    <select
                      ref={txtTipogestion}
                      name="tipo"
                      onChange={onChange}
                      className="form-select form-select-sm text-center"
                      aria-label=".form-select-sm example"
                    >
                      <option value="">--Seleccione--</option>
                      <option value="1">POR CLIENTE</option>
                      <option value="2">POR NOTA DE ENTREGA</option>
                      <option value="3">CREDITO DE VACIO</option>
                    </select>
                  </div>

                  {activnota === 1 ? (
                    <div className="col-pd-420 row m-0 px-1 mx-auto">
                      <div className="input-group input-group-sm mb-2 col-pd-420 px-1">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          N° NOTA DE ENTREGA:{" "}
                        </label>
                        <input
                          disabled={activnota === 1 ? false : true}
                          autoComplete="off"
                          type="text"
                          className="form-control fs-6"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          ref={txtNotaEntrega}
                          onKeyUp={handleNotaEntregaVacio}
                          onBlur={handleNotaEntregaVacio}
                        />
                        <button
                          type="button"
                          onClick={() => setMostrar(true)}
                          className="btn btn-success"
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  ) : activnota === 2 ? (
                    <div className="col-pd-520 row m-0 px-0 mx-auto">
                      <div className="input-group input-group-sm mb-2 col-pd-520 px-0">
                        <label
                          className="input-group-text"
                          id="inputGroup-sizing-sm"
                        >
                          ALMACEN:{" "}
                        </label>
                        <input
                          disabled
                          autoComplete="off"
                          type="text"
                          className="form-control fs-6"
                          aria-label="Sizing example input"
                          aria-describedby="inputGroup-sizing-sm"
                          ref={txtAlmacen}
                        />
                        <button
                          type="button"
                          onClick={() => setMostrar4(true)}
                          className="btn btn-success"
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  <input type="hidden" ref={txtIdalmacen} />
                  <input type="hidden" ref={txtIdcliente} />

                  <div className="input-group input-group-sm mb-2 col-pd-210 px-1 ml-auto">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      FECHA:{" "}
                    </label>
                    <input
                      autoComplete="off"
                      type="date"
                      className="form-control fs-6"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      ref={txtFecha}
                    />
                  </div>

                  <div className="col-12 row m-0 px-0">
                    <div className="input-group input-group-sm mb-2 col-pd-310 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        CEDULA/RIF:{" "}
                      </label>
                      <select
                        ref={cmbRif}
                        name="cmbrif"
                        disabled={activcliente}
                        className="form-select form-select-sm col-md-3 text-center"
                        aria-label=".form-select-sm example"
                      >
                        <option value="">--</option>
                        {cmbCedula &&
                          cmbCedula.map((item, index) => (
                            <option key={index} value={item}>
                              {item}
                            </option>
                          ))}
                      </select>
                      <input
                        ref={txtRif}
                        autoComplete="off"
                        maxLength={12}
                        type="text"
                        disabled={activcliente}
                        className="form-control fs-6 px-1"
                        name="cedula"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        onKeyUp={validarCliente}
                        onBlur={validarCliente}
                      />

                      {activcliente === true ? (
                        ""
                      ) : (
                        <button
                          type="button"
                          onClick={() => setMostra2(true)}
                          className="btn btn-success"
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      )}
                    </div>
                    <div className="input-group input-group-sm mb-2 col-pd-751 px-1">
                      <label
                        className="input-group-text"
                        id="inputGroup-sizing-sm"
                      >
                        NOMBRE:{" "}
                      </label>
                      <input
                        disabled
                        autoComplete="off"
                        type="text"
                        className="form-control fs-6"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        ref={txtCliente}
                      />
                    </div>
                  </div>
                </fieldset>
              </div>

              <div
                className="col-pd-957 border-azul px-0 rounded"
                style={{ /*height: '230px',*/ backgroundColor: "#d5e9ff" }}
              >
                <TblContainer
                  container={{
                    height: 190,
                    width: "100%",
                    overflow: "auto",
                    padding: "2px",
                    fontSizeAdjust: "0.6",
                  }}
                >
                  <TblHead />
                  <TableBody className="overflow-hidden">
                    {records &&
                      records.map((item, index) => (
                        <TableRow key={index} style={{ padding: "0" }}>
                          <TableCell className="align-middle text-center p-0">
                            {item.clasevacio}
                          </TableCell>

                          <TableCell
                            className="align-middle text-right p-0 pl-2"
                            style={{ width: "80px" }}
                          >
                            {activcliente === false ? (
                              <input
                                type="text"
                                className="form-control form-control-sm text-right fs-6"
                                id="despachado"
                                onFocus={seleccionarCampo}
                                defaultValue={formatMoneda(
                                  item.despachado
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                ref={(el) =>
                                  (txtDespachadod.current[index] = el)
                                }
                                onKeyUp={actualizarVacioDespachado(index)}
                                onBlur={actualizarVacioDespachado(index)}
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                            ) : (
                              formatMoneda(
                                item.despachado
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle text-right p-0"
                            style={{ width: "80px" }}
                          >
                            {activcliente === false ? (
                              <input
                                type="text"
                                className="form-control form-control-sm text-right fs-6"
                                id="devuelto"
                                defaultValue={formatMoneda(
                                  item.devuelto
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                ref={(el) => (txtCantidad.current[index] = el)}
                                disabled
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                            ) : (
                              formatMoneda(
                                item.devuelto
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            )}
                          </TableCell>
                          <TableCell
                            className="align-middle text-end p-0 pr-2"
                            style={{ width: "80px" }}
                          >
                            {activcliente === false ? (
                              <input
                                type="text"
                                className="form-control form-control-sm text-right fs-6"
                                id="pendiente"
                                defaultValue={formatMoneda(
                                  item.pendiente
                                    .toString()
                                    .replace(",", "")
                                    .replace(".", ","),
                                  ",",
                                  ".",
                                  2
                                )}
                                disabled
                                ref={(el) => (txtCantidad.current[index] = el)}
                                aria-label="Sizing example input"
                                aria-describedby="inputGroup-sizing-sm"
                              />
                            ) : (
                              formatMoneda(
                                item.pendiente
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )
                            )}
                          </TableCell>

                          <TableCell
                            className="align-middle text-end p-0 pr-2"
                            style={{ width: "80px" }}
                          >
                            <input
                              type="text"
                              className="form-control form-control-sm text-right fs-6"
                              id="cantidad"
                              defaultValue={formatMoneda(
                                item.cantidad
                                  .toString()
                                  .replace(",", "")
                                  .replace(".", ","),
                                ",",
                                ".",
                                2
                              )}
                              ref={(el) => (txtCantidad.current[index] = el)}
                              onFocus={seleccionarCampo}
                              onKeyUp={actualizarVacio(index)}
                              onBlur={actualizarVacio(index)}
                              aria-label="Sizing example input"
                              aria-describedby="inputGroup-sizing-sm"
                            />
                          </TableCell>
                          <TableCell
                            className="align-baseline"
                            style={{
                              textAlign: "center",
                              alignItems: "center",
                              width: "50px",
                            }}
                          >
                            <button
                              className="btn btn-sm mx-1 btn-danger rounded"
                              onClick={eliminarVacio(item)}
                            >
                              <i className="fa fa-trash" />
                            </button>
                          </TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </TblContainer>
              </div>
              <div className="col-pd-120 border-azul px-0 border-4 rounded">
                <div className="col-pd-100 h-50p"></div>
                <div className="col-pd-100 mx-auto mb-2 px-1">
                  <button
                    onClick={() => {
                      if (idAlmacen !== null) {
                        setMostrar3(true);
                      } else {
                        setMensaje({
                          mostrar: true,
                          titulo: "Notificación",
                          texto: "¡ Debe seleccionar el almacen !",
                          icono: "informacion",
                        });
                      }
                    }}
                    className="btn btn-sm btn-primary rounded h-40p"
                    disabled={activ}
                  >
                    <i className="fas fa-plus"> INCLUIR</i>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-4 border-azul px-0 rounded ml-auto border-3">
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    TOTAL VACIOS ENTREGADOS:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtDespachado}
                    value={formatMoneda(
                      notavacio.totaldespachado
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  />
                </div>
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    TOTAL VACIOS RETORNADOS:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtDevuelto}
                    value={formatMoneda(
                      notavacio.totaldevuelto
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  />
                </div>
                <div className="input-group input-group-sm col px-0 ml-auto m-0">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    TOTAL VACIOS PENDIENTES:{" "}
                  </label>
                  <input
                    disabled
                    autoComplete="off"
                    type="text"
                    className="form-control fs-5 h-100 text-right"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    ref={txtPendientes}
                    value={formatMoneda(
                      notavacio.totalpendiente
                        .toString()
                        .replace(",", "")
                        .replace(".", ","),
                      ",",
                      ".",
                      2
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          onClick={onChangeValidar}
          ref={btnAcepta}
          disabled={detavacios}
          style={{ margin: "5px" }}
        >
          <i className="fas fa-check-circle"> Procesar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
      <CatalogoNotaEntregaVacios
        show={mostrar}
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaCatalogo={onCatalogoNotaEntrega}
      />
      <CatalogoCliente
        show={mostra2}
        nomid="vacio"
        onHideCancelar={() => setMostra2(false)}
        onHideAceptaCatalogo={onCatalogoCliente}
      />
      <CatalogoClassVacios
        show={mostrar3}
        idalmacen={null}
        onHideCancelar={() => setMostrar3(false)}
        onHideAceptaCatalogo={onCatalogoClassVacios}
      />
      <CatalogoAlmacen
        show={mostrar4}
        onHideCancelar={() => setMostrar4(false)}
        onHideAceptaCatalogo={onCatalogoAlmacen}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>Cargando...</Loader>
      </Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({
              mostrar: false,
              titulo: "",
              texto: "",
              icono: "",
            });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </Modal>
  );
};
export default GestionarVacios;



// WEBPACK FOOTER //
// ./src/components/vacios/gestionarVacios.js